import React from 'react';

import './deck.scss';

export default class Deck extends React.Component {
    state = {};

    render() {
        return (
            <div className="header">
                { this.props.children }
            </div>
        );
    }
}